<template>
  <div id="app" class="content-container">
    <router-view/>
    <scroll-top></scroll-top>
  </div>
</template>

<script>
  import scrollTop from '@/components/backTop'

  export default {
    name: 'App',
    components: {
      scrollTop
    },
    mounted() {
      setTimeout(() => {
        document.body.removeChild(document.getElementById('Loading'))
      }, 800)
      if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<=9){
        this.$confirm('您的浏览器版本过低，请使用IE9及以上版本，为了更好的浏览效果，请前往其他浏览器打开（'+'http://demo.esaleb.com:8680/'+'）', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
    }
  }
</script>

<style>
  html, body {
    height: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue